import { TagInterface, TagMixin } from 'riot';
import { constants, coreStore, services } from '@ambita/ambita-components-core';

const { core: coreConstants } = constants;

export interface I18nMixin extends TagMixin {
  i18n?: any;
  onLanguageChange(this: TagInterface & I18nMixin): void;
}

export const i18nMixin: I18nMixin = {
  init(this: TagInterface & I18nMixin): void {
    this.i18n = services.i18n.getCurrentTranslation();

    this.on('mount', () => {
      coreStore.on(coreConstants.LANGUAGE_CHANGED_EVENT, this.onLanguageChange);
    });

    this.on('unmount', () => {
      coreStore.off(coreConstants.LANGUAGE_CHANGED_EVENT, this.onLanguageChange);
    });
  },

  onLanguageChange(this: TagInterface & I18nMixin): void {
    this.i18n = services.i18n.getCurrentTranslation();
    this.update();
  }
};

export default i18nMixin;
